import {Component, Input} from '@angular/core';
import {Ng2LoadingBarService, Ng2LoadingBarEvent, Ng2LoadingBarEventType} from '../services/loading-bar-service';
import {ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {AppConfig} from '../app.config';

@Component({
  selector: 'ng2-loading-bar',
  template: `<div #progressBar class="ng2-loading-bar"></div>`,
  styles: [`
      :host {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 9999;
      }
      .ng2-loading-bar {
          transition: all .3s linear;
          box-shadow: 0 0 15px 1px #fff;
      }
  `]
})
export class Ng2LoadingBarComponent {
  @ViewChild('progressBar') progressBar;
  @Input() name: string = 'common';

  public progress = '0%';
  public height = '3px';
  public color = '#fff';
  public display = 'none';

  private serviceSubscription: Subscription = null;

  constructor(public service: Ng2LoadingBarService) {
  }

  ngOnInit(): any {
    let element: any = this.progressBar.nativeElement;

    element.style.width = this.progress;
    element.style.height = this.height;
    element.style.background = this.color;
    element.style.display = this.display;


    this.serviceSubscription = this.service.observable.subscribe((event: Ng2LoadingBarEvent) => {
      let data:any = event.value;
      if (data.name != this.name) return;

      if (event.type === Ng2LoadingBarEventType.PROGRESS) {
        element.style.width = data.value + '%';
      } else if (event.type === Ng2LoadingBarEventType.VISIBLE) {
        element.style.display = data.value ? 'block' : 'none';
      }
    });
  }

  ngOnDestroy() {
    this.serviceSubscription.unsubscribe();
  }
}


// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/loading-bar-component/loading-bar.component.ts